import { render, staticRenderFns } from "./excel-calls-list.vue?vue&type=template&id=867f48aa&scoped=true"
import script from "./excel-calls-list.vue?vue&type=script&lang=js"
export * from "./excel-calls-list.vue?vue&type=script&lang=js"
import style0 from "./excel-calls-list.vue?vue&type=style&index=0&id=867f48aa&prod&lang=scss&scoped=true"
import style1 from "./excel-calls-list.vue?vue&type=style&index=1&id=867f48aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867f48aa",
  null
  
)

export default component.exports